type GtagCommand = "js" | "config";
type Gtag = (command: GtagCommand, target: Date | string) => void;

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: Gtag;
  }
}

const ga4MeasurementId = import.meta.env.VITE_GA4_MEASUREMENT_ID?.trim();

function appendScript(script: HTMLScriptElement) {
  document.head.appendChild(script);
}

function initializeGa4() {
  if (!ga4MeasurementId || document.querySelector("script[data-ga4-loader]")) {
    return;
  }

  const loader = document.createElement("script");
  loader.async = true;
  loader.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(
    ga4MeasurementId
  )}`;
  loader.dataset.ga4Loader = "";

  window.dataLayer = window.dataLayer ?? [];
  window.gtag = function gtag() {
    window.dataLayer?.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", ga4MeasurementId);

  appendScript(loader);
}

export function initializeAnalytics() {
  initializeGa4();
}
